import React, { useState } from 'react';
import './IconButton.css';

const IconButton = ({ icon: Icon, onClick, tooltipText }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="hdg-label-info icon-button-container"
      onMouseEnter={() => setIsHovered(true)} 
      onMouseLeave={() => setIsHovered(false)}
    >
      <button 
        className="icon-button" 
        onClick={onClick} 
        style={{ background: 'transparent', border: 'none', cursor: 'pointer', outline: 'none', width: "fit-content" }}
      >
        <Icon className={`icon ${isHovered ? 'hovered' : ''}`} />
      </button>
      {isHovered && (
        <div className="hdg-label-popup-shown">
          {tooltipText}
        </div>
      )}
    </div>
  );
};

export default IconButton;
